<template lang='pug'>
  r-form(
    ref='form'
    reset-text='restablecer'
    submit-text='guardar'
    v-bind='formProps'
    v-model='slGroupedOffer'
    @reset='submitRefresh'
    @submit='submitCreate'
    )
    template( slot='header-actions' )
      r-dialog(
        content-class='grey lighten-3'
        title='modificar descuento'
        width='540'
        v-model='dialogs.discount'
        )
        r-form(
          submit-text='aplicar'
          v-bind='formDiscountProps'
          v-model='slGroupedOfferDiscount'
          @submit='submitDiscount'
          )
      r-dialog(
        content-class='grey lighten-3'
        title='modificar precio'
        width='540'
        v-model='dialogs.price'
        )
        r-form(
          submit-text='aplicar'
          v-bind='formPercentageProps'
          v-model='slGroupedOfferPrice'
          @submit='submitPrice'
          )
      //r-dialog(
        content-class='grey lighten-3'
        title='busqueda rapida'
        width='540'
        v-model='dialogs.search'
        )
        r-form(
          submit-text='buscar'
          )
    template( slot='sl-selected-grouped-offer-items' )
      v-btn( color='info' @click='showDiscountDialog' ) descuento &nbsp;
        v-icon edit
      v-btn( color='info' @click='showPriceDialog' ) precio &nbsp;
        v-icon edit
      //v-btn( color='secondary' @click='showSearchDialog' ) buscar &nbsp;
        v-icon search
</template>

<script>
  //
  import { RBtnAction, RDialog, RForm } from '@/components/reusable_components/next'
  import translatorService from '@/services/translator'
  //
  import SlGroupedOfferDiscountFields from '@/views/Sale/SlGroupedOffer/SlGroupedOfferDiscountFields'
  import SlGroupedOfferFields from '@/views/Sale/SlGroupedOffer/SlGroupedOfferFields'
  import SlGroupedOfferModel from '@/models/Sale/SlGroupedOffer'
  import SlGroupedOfferPriceFields from '@/views/Sale/SlGroupedOffer/SlGroupedOfferPriceFields'
  //
  export default {
    components: {
      RBtnAction,
      RDialog,
      RForm,
    },
    computed: {
      fieldsProps() {
        return {
          sl_selected_grouped_offer_mapper: this.mapWhProduct,
        }
      },
      formDiscountProps() {
        return {
          fields: SlGroupedOfferDiscountFields,
        }
      },
      formPercentageProps() {
        return {
          fields: SlGroupedOfferPriceFields,
        }
      },
      formProps() {
        return {
          fields: SlGroupedOfferFields(this.fieldsProps),
          title: `crear oferta masiva`
        }
      },
      viewProps() {
        return {
          title: `Crear oferta masiva`,
        }
      },
    },
    data() {
      return {
        slGroupedOffer: new SlGroupedOfferModel({
          sl_offers: [],
        }),
        slGroupedOfferDiscount: {
          discount: 0,
        },
        slGroupedOfferPrice: {
          offer_price: 0,
        },
        dialogs: {
          discount: false,
          price: false,
          search: false,
        },
      }
    },
    methods: {
      getSlGroupedOffer() {
        return SlGroupedOfferModel
          .include('g_branch_office,sl_offers.wh_product')
          .find(this.$route.params.id)
      },
      mapWhProduct(whProduct) {
        //
        whProduct.branchOfficeId = this.$store.getters['AuthModule/branchOfficeID']
        //
        return whProduct
      },
      setSlGroupedOffer(slGroupedOffer) {
        this.slGroupedOffer = slGroupedOffer.reset()
      },
      showDiscountDialog() {
        this.dialogs.discount = true
      },
      showPriceDialog() {
        this.dialogs.price = true
      },
      showSearchDialog() {
        this.dialogs.search = true
      },
      showRefreshError() {
        return this.showErrorSnackbar('Error al cargar oferta masiva.')
      },
      showRefreshSuccess() {
        return this.showSuccessSnackbar('Oferta masiva cargada exitosamente.')
      },
      showCreateError(event) {
        return this.showErrorSnackbar(translatorService(SlGroupedOfferModel, event.response.data))
      },
      showCreateSuccess() {
        return this.showSuccessSnackbar('Oferta masiva creada exitosamente.')
      },
      submitDiscount(event) {
        this
          .slGroupedOffer
          .setDiscount(event.discount)
      },
      submitPrice(event) {
        this
          .slGroupedOffer
          .setPrice(event.offer_price)
      },
      submitReset() {
        this.slGroupedOffer = new SlGroupedOfferModel({
          g_branch_office_id: this.$store.getters['AuthModule/branchOfficeID'],
          sl_offers: [],
        })
      },
      submitCreate() {
        return this
          .toWait(true)
          .then(this.toCreate)
          .then(this.showCreateSuccess)
          .then(this.toRedirect)
          .catch(this.showCreateError)
          .then(this.toWait)
      },
      toCreate() {
        return this
          .slGroupedOffer
          .toCreate()
          .create()
      },
      toRedirect() {
        this.$router.push({ name: 'sl-grouped-offer-list' })
      },
      toWait(value = false) {
        return this.$refs.form.setWait(value)
      },
    },
    created() {
      this.setTitle(this.viewProps.title)
    },
    mounted() {
      this.submitReset()
    }
  }
</script>